import chevronLeft from "@assets/icons/chevron-left.svg";
import chevronRight from "@assets/icons/chevron-right.svg";
import arrowDown from "@assets/icons/arrow-down.svg";
import styles from "./Pagination.module.css";

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  itemsPerPageOptions?: number[];
  disabled?: boolean;
}

function Pagination({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  itemsPerPageOptions = [10, 15, 20, 50],
  disabled = false,
}: PaginationProps) {
  const goToPage = (page: number) => {
    if (disabled) return;
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPagination = () => {
    const pageNumbers: (number | string)[] = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers.map((pageNum, index) => {
      if (pageNum === "...") {
        return (
          <span key={`ellipsis-${index}`} className={styles.paginationEllipsis}>
            ...
          </span>
        );
      }

      return (
        <span
          key={pageNum}
          onClick={() => goToPage(pageNum as number)}
          className={`${styles.paginationPageNumber} ${
            currentPage === pageNum ? styles.active : ""
          }`}
        >
          {pageNum}
        </span>
      );
    });
  };

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.pageCountSelect}>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          disabled={disabled}
        >
          {itemsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <img
          src={arrowDown}
          alt="Arrow Down Icon"
          className={styles.arrowDownIcon}
        />
      </div>
      <div className={styles.pagination}>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1 || disabled}
          className={styles.paginationButton}
        >
          <img src={chevronLeft} alt="Previous" />
        </button>

        {renderPagination()}

        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0 || disabled}
          className={styles.paginationButton}
        >
          <img src={chevronRight} alt="Next" />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
